// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
//   Accordion,
// } from "react-bootstrap";


// const faqData = [
//     {
//         q: "1. What is meant by Deemed Exports? ",
//         a: (
//             <>
//                 <p>"Deemed Exports" refers to transactions where goods are supplied within India and payment is received either in Indian rupees or free foreign exchange.</p>
                
//             </>
//         ),
//     },
//   {
//     q:
//           "2. What types of applications are eligible for Deemed Exports in India?",
//       a: (
//       <>
//        <ul>
//         <li>Refund of Terminal Excise duty</li>
//         <li>Refund of Duty Drawback as per AIR</li>
//         <li>Fixation of brand rate for duty draw back</li>
//        </ul>
//       </>
//     ),
//   },
//  {
//      q: "3. What are the prerequisites for applying for any application under the Deemed Exports system?",
//              a: (
//                  <>
//                  <p>To apply for any application under Deemed Exports, you need to ensure that your user profile is linked with an IEC and that you have a valid digital signature certificate registered in the system. You can verify the status of your DSC by checking "My Dashboard View and Register Digital Signature Token".</p>
//                  </>
//             ),
//     },
//  {
//         q: "4. Am I eligible to apply for applications under the Deemed Exports system if my IEC is in DEL/cancelled/suspended status?",
//         a: (
//             <>
//             <p>You cannot proceed with the submission of your request for applications under deemed exports if your IEC is in DEL status. Similarly, if your IEC is cancelled or suspended, you will not be allowed to proceed with the submission of your request.</p>
//             </>
//      ),
//   },
//   {
//       q: "5. What is view lifecycle? Where can I see it in Deemed Exports?",
      
//         a: (
//             <>
//           <p>Please follow the below path</p>
//                 <ul>
//                     <li>My Dashboard  Submitted Applications.</li>
//                     <li>Enter Type of Scheme (Select in dropdown: Deemed Exports) and Type of Sub Scheme</li>
//                     <li>(Apply for Refund)</li>
//                     <li>Click on Search</li>
//                     <li>Click on Action (Under the Results)  View Life Cycle</li>
//           </ul>
//            </>
//       ),
//   },
//   {
//         q: "6. Where can I see the DSC/e-Sign details of the submitted applications in Deemed Exports?",
//       a: (
//             <>
//               <p>Please follow the below path</p>
//               <ul>
//                   <li>Please follow the below path to view the DSC/e-Sign details of a submitted file for</li>
//                   <li>My Dashboard  Submitted Applications.</li>
//                   <li>Enter Type of Scheme (Select in dropdown: Deemed Exports) and Type of Sub Scheme</li>
//                   <li>(Apply for Refund)</li>
//                   <li>Click on Search</li>
//                   <li>Click on Action (Under the Results) DSC/e-Sign Details</li>
//               </ul>

//             </>
//         ),
//   },
//   {
//         q: "7. What to do if my application is marked as deficient in Deemed Export system?",
//         a: (
//             <>
//             <p>If the File Status of your submitted application under the Deemed Exports system is marked as deficient, please follow these steps to respond to the deficiency raised by the officer:</p>
//                 <ul>
//                 <li>Log in to your account on the Deemed Exports portal and go to "My Dashboard"  "Submitted Applications".</li>
//                 <li>Select the Type of Scheme (Deemed Exports) and the Type of Sub Scheme (Apply for Refund) from the dropdown menus.</li>
//                 <li>Click on "Search" to view the submitted application.</li>
//                 <li>Under "Results", click on "Action"  "Respond Deficiency" for the relevant application.</li>
//                 <li>Click on "View" under "Deficiency view" to view the deficiency letter issued by the officer.</li>
//                 <li>To respond to the deficiency, click on "Respond" under "Respond to Deficiency".</li>
//                 <li>A pop-up will appear asking, "Do you want to amend application?" If you only need to add attachments, click on "NO". If you need to make changes to your application, click on "YES".</li>
//                 </ul>
//                 <p>Upon submission of your response, the life cycle view of the application will be updated for your reference, and the file will be submitted to the RA officer who issued the deficiency letter.</p>
// </>
//         ),
//   },
//   {
//         q: "8. Where can we apply for applications under Deemed Exports?",
//       a: (
//           <>
//               <p>Please follow the below path:</p>
//               <ul>
//                   <li>Services  Deemed Exports</li>
//                   <li>Click on Apply</li>
//               </ul>
//           </>
          
//       ),
//   },
//   {
//         q: "9. How can I add bank account(s) for Deemed Exports application?",
//       a: (
//             <>
//              <p>Bank account details in the Deemed Exports application are automatically pulled from your IEC profile. If you need to add new account details, please modify your IEC profile and add the bank account there. This will ensure that the updated bank account details are reflected in the Deemed Exports application.</p>
//               </>
//         ),
//     },
//   {
//         q: "10. How can I add new bank account details for the re validation request for Deemed Export services",
//         a: (
//             <>
//                <p>To add new bank account details for the re-validation request of Deemed Export services, you need to log in to your account on the Deemed Exports portal and modify your IEC details by adding the new bank account information. This can be done by going to "My Dashboard", selecting "View and Modify IEC Details" under the "Profile Management" section, selecting "Bank Accounts" under the "IEC Details" section, clicking on the "Add" button, entering the new bank account details, and clicking on "Save".</p>
//         </>
//                 ),
//   },
// ];

// export default function EXIM() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                         <div>

//                                   <h1>Deemed Exports and its benefits</h1>
//                                   <p>The Foreign Trade Policy defines ‘Deemed Exports' as goods (not services) made in India that are moved locally and do not leave the country. Deemed export simply indicates that the provider can be paid in either Indian Rupees or convertible foreign currency for this transaction.</p>
//                                   <p>“Deemed exports" for the purpose of GST would include only the supplies notified under section 147 of the CGST/SGST Act, on the recommendations of the GST council. the benefits of GST and conditions applicable for such benefits would be as specified by the GST council and as per relevant rules and notification.</p>
                                 
//                                   <h2>Eligibility requirements for Deemed Exports</h2>
//                                   <p>The following are the FTP conditions that must be met for any transaction to be considered a "deemed export."</p>
                              
//                                   <ul>
//                                       <li>Only commodities are eligible for Deemed Export. Services are not eligible.</li>
//                                       <li>The manufacturing of items must be done in India.</li>
//                                       <li>It is not recommended that the goods be transported outside of India.</li>
//                                       <li>The payment can be made in Indian currency or convertible foreign currency.</li>
//                               </ul>
//                               </div>
//                  </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
            
//         <Row className="g-4 align-items-start">
//                           {/* LEFT CONTENT */}
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <ul>
//                                       <li>A Letter of Undertaking (LUT) or a bond cannot be used to process items submitted as Deemed Export</li>
//                                       <li>The GST on the items should be paid at the time of purchase.</li>
//                                       <li>The GST on the items should be paid at the point of sale. This tax can be claimed for a full refund.</li>
//                                       <li>In case supplier files claim for TED refund, it shall obtain a certificate for non-availment of CENVAT credit from the recipient of goods as per Annexure - I to ANF-7A and submit the same. In case recipient of goods is an applicant, then the applicant itself shall submit such certificate.</li>
//                                   </ul>

//                                   <h2>GST-registered supplies that are deemed to be exports</h2>
//                                   <p>The Central Government has issued Notification No. 48/2017-Central Tax dated 18.10.2017 in exercise of powers provided under Section 147 of the CGST Act, declaring the following categories of commodities supply as Deemed Exports: –</p>
//                                   <p>01. Goods supplied by a registered person under the terms of an Advance Authorization i.e., the supplier must be GST-registered, and the recipient must have an Advance Authorization.</p>
//                                   <p>02. Capital goods supplied by a registered person in accordance with an Export Promotion Capital Goods Authorisation.</p>
//                                   <p>03. Goods supplied to an Export Oriented Unit (EOU) / STP / EHTP /BTP by a registered person (BTP)</p>
//                                   <p>04. Supply of gold by a bank or a public sector undertaking pursuant to an Advance Authorization as defined in Notification No. 50/2017-Customs dated June 30, 2017 (as amended)</p>
                              
//                               <h2>GST taxability of presumed exports</h2>
//                               <p>Supplies that are deemed export supplies are not zero-rated. At the point of sale, all presumed export supplies will be liable to GST. Tax cannot be paid on supplies made under Bond / LUT. Tax should be paid on such a supply, and then a refund obtained.</p>
//                               <p>Refund of tax paid can be sought by either of the following individuals, subject to specific conditions:</p>
//                               <p>1. Goods provider OR</p>
//                               <p>2. A person who receives goods.</p>
//                               <p>Note that if the supplier is claiming a refund of tax paid, the recipient is not able to claim the input tax credit (ITC).</p>
                              
//                                   <h2>Extra requirements for presumed exports to EOU/STP/EHTP/BTP</h2>
//                                   <p>1. The EOU/ EHTP/ STP/ BTP unit must notify the supplier and the jurisdictional GST officer of the supplier and the recipient as a recipient by filing Form A (attached hereto).</p>
//                                   <p>2. Form A must have a running serial number and contain details of the goods to be procured, which the Development Commissioner has pre-approved.</p>
//                                   <p>3. The supplier must then deliver goods accompanied by a tax invoice.</p>
//                                   <p>4. The recipient must sign the tax invoice. The supplier, as well as the jurisdictional GST officer of the supplier and the recipient as a recipient, shall receive an endorsed copy of the same.</p>
//                                   <p>5. Form B must be used to keep track of the goods received by the EOU/ EHTP/ STP/ BTP unit (Appended herewith).</p>
                              
//                                   <h2>Procedure for receiving a refund of GST paid on considered exports</h2>
//                                   <p>To get a refund, you'll need the following documentation:</p>
//                                   <p>The following information/documents must be provided if the supplier is demanding a refund of tax paid on considered exports:</p>
//                                   <ul>
//                                       <li>A statement detailing invoice-level data of the supplier's presumed export supplies.</li>
//                                       <li>In the case of EOU/ EHTP/ STP/ BTP/ Copy of tax invoice signed by the recipient, acknowledgment by jurisdiction tax officer of AA or EPCG holder that the said deemed export supplies have been received OR in the case of EOU/ EHTP/ STP/ BTP/ Copy of tax invoice signed by the recipient that the said deemed export supplies have been received.</li>
//                                       <li>The recipient swears that no ITC has been claimed.</li>
//                                       <li>The recipient agrees not to seek a refund for such supplies.</li>
//                               </ul>

//                                   <h2>The Advantages of the Deemed Exports Scheme</h2>
//                                   <p>The following benefits are available to commodities that are eligible to be considered deemed exports:</p>
//                                   <ul>
//                                       <li>Advance License / Advance licence for annual requirement / DFIA.</li>
//                                       <li>Deemed Export Drawback.</li>
//                                       <li>Refund of terminal excise duty for excisable goods mentioned in Schedule 4 of Central Excise Act 1944 provided the supply is eligible under that category of deemed exports and there is no exemption.</li>
//                                   </ul>

//                                   <h2>Conditions for refund of deemed export drawback</h2>
//                                   <p>Supplies will be eligible for deemed export drawback as per para 7.03(b) of FTP as under:</p>
//                                   <p>Refund of drawback on the inputs used in manufacture and supply under the said category can be claimed on ‘All Industry Rate’ of Duty Drawback Schedule notified by Department of Revenue from time to time provided no CENVAT credit has been availed by supplier of goods on excisable inputs or on ‘Brand Rate Basis’ upon submission of documents evidencing actual payment of basic custom duties.</p>
                                  
//                                   <h2>At Apex  What We Do</h2>
//                                   <p>At Apex Professional Services, we give you a detailed explanation of the terms and conditions of the benefits of Deemed exports and will help you in applying the benefits of Deemed exports from DGFT.</p>


//                               </div>
                              

//     </Col>
//             </Row>
//             </Container>
//         </section>
        

//         {/* ===== FAQ SECTION ===== */}
//          <section className="py-5 bg-light faq-section">
//                   <Container>
//                       {/* <h2 className="text-center mb-4">Frequently Asked Questions on Importer-Exporter Code (IEC)/(E-IEC)</h2> */}
//             <Accordion defaultActiveKey="0" className="custom-faq">
//                         {faqData.map((f, i) => (
//                           <Accordion.Item eventKey={String(i)} key={i}>
//                             <Accordion.Header>{f.q}</Accordion.Header>
//                             <Accordion.Body>{f.a}</Accordion.Body>
//                           </Accordion.Item>
//                         ))}
//                       </Accordion>
//                     </Container>
//                     </section>
//                   </div>
//                   </>
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGlobe,
  FaList,
  FaRocket,
  FaIndustry,
  FaHandsHelping,
  // FaExclamationTriangle
} from "react-icons/fa";
import { Accordion } from "react-bootstrap";

export default function DeemedExports() {

  const faqData = [
    {
      q: "What are Deemed Exports?",
      a: "Supplies made within India that are treated as exports under Foreign Trade Policy and eligible for benefits.",
    },
    {
      q: "Who can apply?",
      a: "Manufacturers, suppliers, contractors, and exporters dealing with eligible projects or entities.",
    },
    {
      q: "What benefits are available?",
      a: "TED refund, Duty Drawback, and Brand Rate Fixation benefits.",
    },
    {
      q: "Are services covered?",
      a: "No, only supply of goods is covered under deemed exports.",
    },
    {
      q: "Can both supplier and buyer claim benefits?",
      a: "No, only one party can claim benefits based on eligibility.",
    },
  ];

  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">
            <Col lg={8}>
              <h1>
                Deemed Export Benefits (TED / Duty Drawback / Brand Rate)
              </h1>

              <p>
                Deemed exports are supplies made within India but treated as
                exports under Foreign Trade Policy, allowing businesses to claim
                various export incentives.
              </p>

              <p>
                These benefits help improve profitability, reduce tax burden,
                and support domestic manufacturing.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your right-side form */}
            </Col>
          </Row>

          {/* WHAT IS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> What are Deemed Exports?
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Goods supplied within India</li>
            <li><FaCheckCircle /> Treated as exports under FTP</li>
            <li><FaCheckCircle /> Eligible for export incentives</li>
            <li><FaCheckCircle /> Payment can be in INR or forex</li>
          </ul>

          {/* COVERED SUPPLIES */}
          <h2 className="section-title">
            <FaList className="icon" /> Supplies Covered
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Supply against Advance Authorisation / DFIA</li>
            <li><FaCheckCircle /> Supply to EOU / STP / EHTP / BTP units</li>
            <li><FaCheckCircle /> Supply against EPCG Authorisation</li>
            <li><FaCheckCircle /> Supply to mega power and infrastructure projects</li>
            <li><FaCheckCircle /> Supply to UN / international organizations</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Benefits Available
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Terminal Excise Duty (TED) refund</li>
            <li><FaCheckCircle /> Duty Drawback benefits</li>
            <li><FaCheckCircle /> Brand Rate fixation</li>
            <li><FaCheckCircle /> Duty-free procurement benefits</li>
          </ul>

          {/* GST */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Deemed Exports under GST
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Only goods are covered (not services)</li>
            <li><FaCheckCircle /> GST is paid first, then refund claimed</li>
            <li><FaCheckCircle /> Supplies notified under GST law</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Eligibility
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Manufacturers and suppliers</li>
            <li><FaCheckCircle /> Contractors for eligible projects</li>
            <li><FaCheckCircle /> Businesses under FTP schemes</li>
            <li><FaCheckCircle /> GST and DGFT compliant entities</li>
          </ul>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Application Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Identify eligible transactions</li>
            <li><FaCheckCircle /> Prepare documents</li>
            <li><FaCheckCircle /> File application</li>
            <li><FaCheckCircle /> Authority verification</li>
            <li><FaCheckCircle /> Receive refund or benefits</li>
          </ul>

          {/* BENEFITS IMPACT */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Key Advantages
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Recovery of taxes and duties</li>
            <li><FaCheckCircle /> Improved cash flow</li>
            <li><FaCheckCircle /> Better project profitability</li>
            <li><FaCheckCircle /> Competitive advantage</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            We assist in eligibility assessment, documentation, filing,
            and coordination with DGFT, GST, and customs authorities
            to ensure smooth claim processing and maximum benefits.
          </p>

          {/* FAQ */}
          <h2 className="section-title mt-4">Frequently Asked Questions</h2>

          <Accordion defaultActiveKey="0" className="custom-faq">
            {faqData.map((f, i) => (
              <Accordion.Item eventKey={String(i)} key={i}>
                <Accordion.Header>{f.q}</Accordion.Header>
                <Accordion.Body>{f.a}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>

        </Container>
      </section>
    </div>
  );
}